import { useSignupSelector } from "../hooks";
import { State } from "../state/types";
import { selectAnimalById } from "./animals";

export const selectCurrentInsuranceByAnimalId = (state: State, id?: string) => {
  if (!id) {
    throw new Error("No ID was provided");
  }

  const animal = selectAnimalById(state, id);

  if (!animal) {
    throw new Error(`No animal found for animal ${id}`);
  }

  return animal.insurances[0];
};

export const useCurrentInsuranceByAnimalId = (id: string) =>
  useSignupSelector((state) => selectCurrentInsuranceByAnimalId(state, id));
